import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Select from 'react-select';
import {Field} from 'react-final-form';

import {
  fieldIsRequired,
} from '../../../configs/messages';

export default class SelectField extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    validatorsArray: PropTypes.arrayOf(PropTypes.func),
    label: PropTypes.string,
    labelSize: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    rowGap: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    multi: PropTypes.bool,
    clearable: PropTypes.bool,
    onSelect: PropTypes.func,
    errorPosition: PropTypes.string,
    searchable: PropTypes.bool,
  };

  static defaultProps = {
    validatorsArray: [],
    label: '',
    labelSize: 's',
    placeholder: '',
    required: false,
    rowGap: 's',
    multi: false,
    clearable: false,
    onSelect: null,
    errorPosition: 'right',
    searchable: true,
  };

  requiredValidator = value => (value ? null : fieldIsRequired)

  composeValidators = (...validators) => (value, allValues) =>
    validators.reduce((error, validator) => error || validator(value, allValues), undefined)

  reactSelectAdapter = ({input, ...rest}) => {
    const {
      name,
      label,
      labelSize,
      rowGap,
      errorPosition,
      searchable,
    } = this.props;

    const onChange = ({value}) => {
      const {onSelect} = this.props;
      if (onSelect) {
        onSelect(value);
      }

      input.onChange(value);
    };

    const {meta} = rest;
    const {error} = meta;
    const labelClasses = classNames(
      'form__label',
      {
        [`form__label_${labelSize}`]: Boolean(labelSize),
      }
    );
    const formRowClasses = classNames(
      'form__row',
      {
        [`form__row_gap_${rowGap}`]: Boolean(rowGap),
      }
    );
    const formErrorClasses = classNames(
      'form__error',
      {
        [`form__error_${errorPosition.split(' ').join('_')}`]: Boolean(errorPosition),
      }
    );

    return (
      <div className={formRowClasses}>
        {label && <label className={labelClasses} htmlFor={name}>{label}</label>}
        <div className="form__error-wrap">
          <Select
            {...input}
            {...rest}
            id={name}
            onChange={onChange}
            searchable={searchable}
          />
          {error && meta.touched &&
            <span className={formErrorClasses}>{error}</span>
          }
        </div>
      </div>
    );
  }

  render() {
    const {
      name,
      required,
      validatorsArray,
      options,
      multi,
      clearable,
      placeholder,
      ...input
    } = this.props;

    if (required) {
      validatorsArray.push(this.requiredValidator);
    }

    return (
      <Field
        {...input}
        name={name}
        component={this.reactSelectAdapter}
        validate={this.composeValidators(...validatorsArray)}
        multi={multi}
        placeholder={placeholder}
        clearable={clearable}
        options={options}
      />
    );
  }
}
